// extracted by extract-css-chunks-webpack-plugin
module.exports = {"rightContent":"rightContent-YTz5ZECo"};